.logoutButton {
  background-color: transparent;
  border: none;
  cursor: pointer;
  &:hover {
    background-color: #f2f2f2;
  }
}
